import JSZip from 'jszip';

async function zipFiles(files){
  const zip = new JSZip();
  for (let file of files){
    zip.file(file.name, file.file_body_encode, {base64: true});
    // console.log(`file name === ${file.name} \n ${file.file_body_full}`)
  }

  const zipFile = await zip.generateAsync({type : 'base64'});
  console.log(`zipFile === ${zipFile}`);
  console.log(`zipFile size === ${zipFile.length}`);
  return zipFile;
}

async function getZipFile(caseId, files){
  // 壓縮檔案
  const fileName = `${new Date().getTime()}.zip`
  const newZip = await zipFiles(files);
  console.log('== newZip start ==');
  console.log(newZip);
  console.log('== newZip ==');
  const fileItem = { name: `caseFiles/${caseId}/${fileName}`,
    fileName: fileName,
    caseId: caseId,
    image: `data:application/zip;base64,${newZip}`,
    file: newZip, url:'' };

  return fileItem;
}

async function getZipFileByName(caseId, filename, files){
  // 壓縮檔案
  const fileName = `${filename}.zip`
  const newZip = await zipFiles(files);
  console.log('== newZip start ==');
  console.log(newZip);
  console.log('== newZip ==');
  const fileItem = { name: `caseFiles/${caseId}/${fileName}`,
    fileName: fileName,
    caseId: caseId,
    image: `data:application/zip;base64,${newZip}`,
    file: newZip, url:'' };

  return fileItem;
}

export {
  getZipFile,
  zipFiles,
  getZipFileByName
}



// WEBPACK FOOTER //
// ./src/pages/utils/zip.js